import { ListItem } from "@design";
import { MessageCircle } from "lucide-react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router";
import type { SpaceHubResponse } from "@/api";
import { SectionEmpty } from "@/components/section";
import { Text } from "@/components/Text";
import { formatRelativeTime } from "@/i18n/format";
import { SpaceSection } from "./SpaceSection";

export function RecentChatsSection({ space }: Readonly<{ space: SpaceHubResponse }>) {
  const { t } = useTranslation("spaces", { keyPrefix: "detail.recentChats" });
  const navigate = useNavigate();
  const chats = (space.recentChats ?? []).slice(0, 5);
  return (
    <SpaceSection
      title={t("title")}
      action={{ label: t("all"), onClick: () => navigate(`/spaces/${space.uuid}/chats`) }}
    >
      {chats.length === 0 ? (
        <SectionEmpty icon={<MessageCircle size={18} />} hint={t("empty")} />
      ) : (
        <ul>
          {chats.map((chat) => (
            <li key={chat.uuid}>
              <ListItem
                flat
                onClick={() => navigate(`/chat/${chat.uuid}`)}
                leading={<MessageCircle size={15} className="text-content-tertiary" />}
                description={chat.agentName ?? chat.userName ?? undefined}
                trailing={
                  <Text as="span" variant="caption" tone="tertiary" className="shrink-0">
                    {formatRelativeTime(chat.updatedAt)}
                  </Text>
                }
              >
                {chat.title || t("untitled")}
              </ListItem>
            </li>
          ))}
        </ul>
      )}
    </SpaceSection>
  );
}
